import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import AddPrograms from './addprograms.js';
import CircularProgress from '@mui/material/CircularProgress';
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import Selectsearch from "react-select";
import {
    FormGroup,
    Label,

} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    addAgreement,
    agreementAllDetails,
} from 'Actions';


class AddAgreement extends React.Component {
    constructor(props) {
        super(props);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
        this.state = {
            addprogram: false,
            adddiv: true,
            frstdate_1: '',
            frenddate_1: '',
            student: this.props.particularcontractstudent.student[0],
            parent: this.props.particularcontractstudent.parent[0],
            agreement: this.props.particularcontractstudent.agreements[0],
            program: this.props.particularcontractstudent.program,
            studentid: this.props.particularcontractstudent.student[0].uudID,
            parentid: this.props.particularcontractstudent.student[0].uud_pid,
            exstudentid: this.props.particularcontractstudent.student[0].uudID,
            edcontactid: this.props.particularcontractstudent.student[0].uud_ctID,
            selectedProgramIds: [],
            edagreement: 0,
            parentage: 0,
            studentage: 0,
            startdate: '',
            startdatefee1: '',
            startdatefee2: '',
            startdatefee3: '',
            startdatefee4: '',
            startdatefee5: '',
            startdatefee6: '',
            startdatefee7: '',
            startdatefee8: '',
            startdatefee9: '',
            startdatefee10: '',
            startdatefee11: '',
            startdatefee12: '',
            enddate: '',
            enddatefee1: '',
            enddatefee2: '',
            enddatefee3: '',
            enddatefee4: '',
            enddatefee5: '',
            enddatefee6: '',
            enddatefee7: '',
            enddatefee8: '',
            enddatefee9: '',
            enddatefee10: '',
            enddatefee11: '',
            enddatefee12: '',
            execdate: '',
            execdatefee1: '',
            execdatefee2: '',
            execdatefee3: '',
            execdatefee4: '',
            execdatefee5: '',
            execdatefee6: '',
            execdatefee7: '',
            execdatefee8: '',
            execdatefee9: '',
            execdatefee10: '',
            execdatefee11: '',
            execdatefee12: '',
            finyearsel: '',
            selagreementfor:'',
            selagreementtype:'',
            finyearfee1: '',
            finyearfee2: '',
            finyearfee3: '',
            finyearfee4: '',
            finyearfee5: '',
            finyearfee6: '',
            finyearfee7: '',
            finyearfee8: '',
            finyearfee9: '',
            finyearfee10: '',
            finyearfee11: '',
            finyearfee12: '',
            loader: false,

        };
        this.addHandleSubmit = this.addHandleSubmit.bind(this);
        this.calculateTax = this.calculateTax.bind(this);
        this.onBackSection = this.onBackSection.bind(this);
    }

    UNSAFE_componentWillMount() {
        // this.props.agreementAllDetails();

        var parentdob = this.state.parent.uud_dob;
        var studentdob = this.state.student.uud_dob;

        var parentage = this.calculate_age(parentdob);
        var studentage = this.calculate_age(studentdob);
        this.setState({
            parentage: parentage,
            studentage: studentage
        });
    }

    onBackSection() {
        this.props.onClick();
        // this.setState({            
        //     addprogram:false,
        //     adddiv:true,
        // });
    }

    calculate_age = (dob1) => {

        var today = new Date();
        var birthDate = new Date(dob1);
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age_now--;
        }

        return age_now;
    }

    selfinancialyear(e) {
        
        var selval = e.value;
        this.setState({
            finyearsel: selval
        });

        
    }

    selfinyearfee(e, id) {
        
        const selval = e.value;   
        const selyearfee = "finyearfee"+id;
        this.setState({
            [selyearfee]: selval
        });
    }

    selectstartdate = (date, id) => {
        
        const seldate = moment(new Date(date)).format('yyyy-MM-DD');
        const oneyeardate = moment(date).add(1, "year").subtract(1, "day").toDate();
        
        if (id == 1) {
            this.setState({
                startdate: date,
                startdatefee1: date,
                startdatefee2: date,
                startdatefee3: date,
                startdatefee4: date,
                startdatefee5: date,
                startdatefee6: date,
                startdatefee7: date,
                startdatefee8: date,
                startdatefee9: date,
                startdatefee10: date,
                startdatefee11: date,
                startdatefee12: date,
            });

            this.setState({
                enddate: oneyeardate,
                enddatefee1: oneyeardate,
                enddatefee2: oneyeardate,
                enddatefee3: oneyeardate,
                enddatefee4: oneyeardate,
                enddatefee5: oneyeardate,
                enddatefee6: oneyeardate,
                enddatefee7: oneyeardate,
                enddatefee8: oneyeardate,
                enddatefee9: oneyeardate,
                enddatefee10: oneyeardate,
                enddatefee11: oneyeardate,
                enddatefee12: oneyeardate,
            });
        } else if (id == 2) {
            this.setState({
                enddate: date,
                enddatefee1: date,
                enddatefee2: date,
                enddatefee3: date,
                enddatefee4: date,
                enddatefee5: date,
                enddatefee6: date,
                enddatefee7: date,
                enddatefee8: date,
                enddatefee9: date,
                enddatefee10: date,
                enddatefee11: date,
                enddatefee12: date,
            });
        } else if (id == 3) {
            this.setState({
                execdate: date,
                execdatefee1: date,
                execdatefee2: date,
                execdatefee3: date,
                execdatefee4: date,
                execdatefee5: date,
                execdatefee6: date,
                execdatefee7: date,
                execdatefee8: date,
                execdatefee9: date,
                execdatefee10: date,
                execdatefee11: date,
                execdatefee12: date,
            });
        }


    }

    startfeedate = (date, fild, id) => {

        if (fild == 1) {
            const seldate = "startdatefee" + id;
            this.setState({
                [seldate]: date
            });

        } else if (fild == 2) {

            const seldate = "enddatefee" + id;
            this.setState({
                [seldate]: date
            });

        } else if (fild == 3) {
            const seldate = "execdatefee" + id;
            this.setState({
                [seldate]: date
            });
        }


    }

    handleDateChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleCheckboxChange = (e, programId) => {
        const { checked } = e.target;
        if (checked) {
            this.setState((prevState) => ({
                selectedProgramIds: [...prevState.selectedProgramIds, programId],
            }));
        } else {
            this.setState((prevState) => ({
                selectedProgramIds: prevState.selectedProgramIds.filter((id) => id !== programId),
            }));
        }
    };

    // Row is active only when Year is selected or Fee is entered; unused rows are not required.
    isFeeBreakupRowActive = (rowIndex, feeValue) => {
        const year = this.state['finyearfee' + rowIndex];
        const fee = feeValue !== undefined ? feeValue : this.state[`frfees_${rowIndex}`];
        const hasYear = year !== '' && year != null;
        const hasFee = fee !== '' && fee != null && fee !== undefined;
        return hasYear || hasFee;
    };

    validateFeeBreakupRows = (formData) => {
        for (let i = 1; i <= 12; i++) {
            const year = this.state['finyearfee' + i];
            const fee = formData.get('frfees_' + i);
            const tax = formData.get('frtax_' + i);
            const startDate = formData.get('frstdate_' + i);
            const endDate = formData.get('frenddate_' + i);
            const dueDate = formData.get('frduedate_' + i);

            if (!this.isFeeBreakupRowActive(i, fee)) {
                continue;
            }

            if (!year) {
                alert('Please select the Fee BreakUp Year in the row ' + i);
                return false;
            }
            if (!startDate) {
                alert('Please select the Fee BreakUp Start Date in the row ' + i);
                return false;
            }
            if (!endDate) {
                alert('Please select the Fee BreakUp End Date in the row ' + i);
                return false;
            }
            if (fee === '' || fee == null) {
                alert('Please enter the Fee BreakUp Fee in the row ' + i);
                return false;
            }
            if (tax === '' || tax == null) {
                alert('Please enter the Fee BreakUp Tax in the row ' + i);
                return false;
            }
            if (!dueDate) {
                alert('Please select the Fee BreakUp Due Date in the row ' + i);
                return false;
            }
        }
        return true;
    };

    addHandleSubmit = (event) => {
        event.preventDefault();
        
        const formData = new FormData(event.target);
        const {  finyearsel, selagreementfor, selagreementtype, finyearfee1, finyearfee2, finyearfee3, finyearfee4, finyearfee5, finyearfee6, finyearfee7, finyearfee8, finyearfee9, finyearfee10, finyearfee11, finyearfee12 } = this.state;
        
        const selectedFinancialYear = finyearsel;

        const selectedAgreementType = selagreementtype;

        const agreementStartDateInput = document.getElementsByName('agreementstdate')[0];
        const selectedAgreementStartDate = agreementStartDateInput.value;

        const agreementEndDateInput = document.getElementsByName('agreementenddate')[0];
        const agreementExecutionDateInput = document.getElementsByName('agreementextdate')[0];

        const selectedAgreementEndDate = agreementEndDateInput.value;
        const selectedAgreementExecutionDate = agreementExecutionDateInput.value;

        if(selectedFinancialYear==''){
            alert('Please select the Financial Year');
        }else if(selectedAgreementType==''){
            alert('Please select the Agreement Type');
        }else if(selagreementfor==''){
            alert('Please select the Agreement For');
        }else if(!this.validateFeeBreakupRows(formData)){
            return;
        }else{

            this.setState({ loader: true });

            const requestBody = {
                financialyear: selectedFinancialYear,
                agreementtype: selectedAgreementType,
                agreementstdate: selectedAgreementStartDate,
                agreementenddate: selectedAgreementEndDate,
                agreementextdate: selectedAgreementExecutionDate,
                program: formData.get('program'),
                parentage: formData.get('parentage'),
                agreementfor: selagreementfor,
                parentaddress: formData.get('parentaddress'),
                studentage: formData.get('studentage'),
                studentaddress: formData.get('studentaddress'),
                fryear_1: finyearfee1,
                frstdate_1: formData.get('frstdate_1'),
                frenddate_1: formData.get('frenddate_1'),
                frfees_1: formData.get('frfees_1'),
                frtax_1: formData.get('frtax_1'),
                frduedate_1: formData.get('frduedate_1'),
                fryear_2: finyearfee2,
                frstdate_2: formData.get('frstdate_2'),
                frenddate_2: formData.get('frenddate_2'),
                frfees_2: formData.get('frfees_2'),
                frtax_2: formData.get('frtax_2'),
                frduedate_2: formData.get('frduedate_2'),
                fryear_3: finyearfee3,
                frstdate_3: formData.get('frstdate_3'),
                frenddate_3: formData.get('frenddate_3'),
                frfees_3: formData.get('frfees_3'),
                frtax_3: formData.get('frtax_3'),
                frduedate_3: formData.get('frduedate_3'),
                fryear_4: finyearfee4,
                frstdate_4: formData.get('frstdate_4'),
                frenddate_4: formData.get('frenddate_4'),
                frfees_4: formData.get('frfees_4'),
                frtax_4: formData.get('frtax_4'),
                frduedate_4: formData.get('frduedate_4'),
                fryear_5: finyearfee5,
                frstdate_5: formData.get('frstdate_5'),
                frenddate_5: formData.get('frenddate_5'),
                frfees_5: formData.get('frfees_5'),
                frtax_5: formData.get('frtax_5'),
                frduedate_5: formData.get('frduedate_5'),
                fryear_6: finyearfee6,
                frstdate_6: formData.get('frstdate_6'),
                frenddate_6: formData.get('frenddate_6'),
                frfees_6: formData.get('frfees_6'),
                frtax_6: formData.get('frtax_6'),
                frduedate_6: formData.get('frduedate_6'),
                fryear_7: finyearfee7,
                frstdate_7: formData.get('frstdate_7'),
                frenddate_7: formData.get('frenddate_7'),
                frfees_7: formData.get('frfees_7'),
                frtax_7: formData.get('frtax_7'),
                frduedate_7: formData.get('frduedate_7'),
                fryear_8: finyearfee8,
                frstdate_8: formData.get('frstdate_8'),
                frenddate_8: formData.get('frenddate_8'),
                frfees_8: formData.get('frfees_8'),
                frtax_8: formData.get('frtax_8'),
                frduedate_8: formData.get('frduedate_8'),
                fryear_9: finyearfee9,
                frstdate_9: formData.get('frstdate_9'),
                frenddate_9: formData.get('frenddate_9'),
                frfees_9: formData.get('frfees_9'),
                frtax_9: formData.get('frtax_9'),
                frduedate_9: formData.get('frduedate_9'),
                fryear_10: finyearfee10,
                frstdate_10: formData.get('frstdate_10'),
                frenddate_10: formData.get('frenddate_10'),
                frfees_10: formData.get('frfees_10'),
                frtax_10: formData.get('frtax_10'),
                frduedate_10: formData.get('frduedate_10'),
                fryear_11: finyearfee11,
                frstdate_11: formData.get('frstdate_11'),
                frenddate_11: formData.get('frenddate_11'),
                frfees_11: formData.get('frfees_11'),
                frtax_11: formData.get('frtax_11'),
                frduedate_11: formData.get('frduedate_11'),
                fryear_12: finyearfee12,
                frstdate_12: formData.get('frstdate_12'),
                frenddate_12: formData.get('frenddate_12'),
                frfees_12: formData.get('frfees_12'),
                frtax_12: formData.get('frtax_12'),
                frduedate_12: formData.get('frduedate_12'),
                programinclusion: this.state.selectedProgramIds,
                student_id: this.state.studentid,
                contact_id: this.state.edcontactid
            };
             
            this.props.addAgreement(requestBody).then((data) => {
                if (data.status === 1) {
                    var resdata = data.data;

                    this.setState({

                        edagreement: resdata.id,
                        student: '',
                        seldate: '',
                        loader: false,
                    });

                    document.getElementById("addform").reset();

                    this.setState({
                        adddiv: false,
                        addprogram: true,
                    });
                }
            });

        }
    }

    calculateTax(event) {
        const fieldNumber = parseInt(event.target.getAttribute('data-field-number'));
        const am = parseFloat(event.target.value);
        const ta = 18;
        const total = (am * ta) / 100;

        this.setState({
            [`frfees_${fieldNumber}`]: am,
            [`frtax_${fieldNumber}`]: (am ? total : ''),
        });
    }

    render() {
        const { allagreementfinancial, allagreementtype, allagreementfor, allagreementprogram, loading } = this.props;
        const { frstdate_1, frenddate_1, frduedate_1, frstdate_2, frenddate_2, frduedate_2, frstdate_3, frenddate_3, frduedate_3, frstdate_4, frenddate_4, frduedate_4 } = this.state;
        
        const agreementtype = allagreementtype;
        const financialyear = allagreementfinancial;
        const agreementfor = allagreementfor;
        
        const styles = {
            buttonProgress: {
                color: "blue",
                position: 'absolute',
                top: '65%',
                left: '50%',
                marginTop: -15,
                marginLeft: -15,
            },
            wrapper: {
                position: 'relative',
                textAlign: "center"
            },
        };
        return (
            <>
                {this.state.adddiv && (
                    <div className="row gx-3">
                        <div className="col-sm-12 col-lg-12">
                            <form autoComplete="off" id="addform" onSubmit={this.addHandleSubmit}>
                                <RctCollapsibleCard
                                    heading={
                                        <div style={{ display: 'flex', alignItems: 'center', borderBottom: "1px solid #ccc" }}>
                                            <span>Details</span>
                                            <button type="button" className="mr-3 mb-3 btn btn-outline-warning ml-auto" onClick={this.props.onClick}>Back</button>
                                        </div>
                                    }
                                >
                                    <div class="row spetdiv" style={{ borderBottom: "2px solid #ccc" }}>
                                        <div class="col-12">
                                            <h3>Student Profile </h3>
                                        </div>
                                        <div class="col-6">
                                            <p>Name : <span id="adstudname"><strong>{this.state.student.uud_firstName + ' ' + this.state.student.uud_lastName}</strong> </span></p>
                                            <p>Email : <span id="adstudemail"><strong>{this.state.student.uud_email}</strong></span></p>
                                            <p>Mobile : <span id="adstudmobile"><strong>{this.state.student.uud_phone}</strong></span></p>
                                            <p>Date Of Birth :  <span id="adstuddob"><strong>{this.state.student.uud_dob}</strong></span></p>
                                            <p>Blood Group : <span id="adstudblood"><strong>{this.state.student.ctsd_bloodgroup}</strong></span></p>
                                        </div>
                                        <div class="col-6">
                                            <p>Food Preference : <span id="adstudfood"><strong>{this.state.student.ctsd_food}</strong></span></p>
                                            <p>Food Allergies : <span id="adstudfoodaller"><strong>{this.state.student.ctsd_foodallergies}</strong></span></p>
                                            <p>Medical Condition : <span id="adstudmedical"><strong>{this.state.student.ctsd_medical}</strong></span></p>
                                            <p>Any Other Information :  <span id="adstudothdetails"><strong>{this.state.student.ctsd_otherdetails}</strong></span></p>
                                        </div>
                                    </div>
                                    <div class="container-fluid pt-3" style={{ borderBottom: "2px solid #ccc" }}>
                                        <div className="d-flex justify-content-between mb-3">
                                            <div className="dfsdf"><strong>Add Edit Agreement</strong></div>
                                        </div>

                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label">Financial Year*</label>
                                            <div class="col-sm-4">
                                                <FormGroup>
                                                    <Label for="Select">select</Label>
                                                    <Selectsearch
                                                        options={financialyear.map(finval => ({ value: finval.id, label: finval.name }))}                                                        
                                                        value={financialyear.find(obj => obj.value === this.state.finyearsel)}
                                                        search
                                                        onChange={(e) => this.selfinancialyear(e)}
                                                        required
                                                    />
                                                </FormGroup>
                                            </div>

                                            <label class="col-sm-2 col-form-label">Agreement Type*</label>
                                            <div class="col-sm-4">
                                                <FormGroup>
                                                    <Label for="Select">select</Label>
                                                    <Selectsearch
                                                        options={agreementtype.map(finval => ({ value: finval.id, label: finval.name }))}
                                                        value={agreementtype.find(obj => obj.value === this.state.selagreementtype)}
                                                        search
                                                        onChange={(e) => this.setState({ selagreementtype:e.value  })}
                                                        required
                                                    />
                                                </FormGroup>

                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label">Agreement Start Date*</label>
                                            <div class="col-sm-4">

                                                <DatePicker className="form-control" id="agreementstdate" name="agreementstdate" autoComplete="off" required
                                                    selected={this.state.startdate}
                                                    onChange={(e) => this.selectstartdate(e, 1)}
                                                    dateFormat='yyyy-MM-dd'
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                />
                                            </div>
                                            <label class="col-sm-2 col-form-label">Agreement End Date*</label>
                                            <div class="col-sm-4">
                                                <DatePicker className="form-control" id="agreementenddate" name="agreementenddate" autoComplete="off" required
                                                    selected={this.state.enddate}
                                                    onChange={(e) => this.selectstartdate(e, 2)}
                                                    dateFormat='yyyy-MM-dd'
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label">Agreement Execution Date*</label>
                                            <div class="col-sm-4">
                                                <DatePicker className="form-control" id="agreementextdate" name="agreementextdate" autoComplete="off" required
                                                    selected={this.state.execdate}
                                                    onChange={(e) => this.selectstartdate(e, 3)}
                                                    dateFormat='yyyy-MM-dd'
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                />
                                            </div>
                                            <label class="col-sm-2 col-form-label">Parent Age *</label>
                                            <div class="col-sm-4">
                                                <input type="text" name="parentage" value={this.state.parentage} class="form-control"
                                                    onChange={(e) => this.setState({ parentage: e.target.value })} />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label">Agreement For*</label>
                                            <div class="col-sm-4">
                                                <FormGroup>
                                                    <Label for="Select">select</Label>
                                                    <Selectsearch
                                                        options={agreementfor.map(finval => ({ value: finval.id, label: finval.name }))}
                                                        search
                                                        value={agreementfor.find(obj => obj.value === this.state.selagreementfor)}
                                                        onChange={e => this.setState({ selagreementfor:e.value  })}
                                                        required
                                                    />
                                                </FormGroup>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label">Parent Address*</label>
                                            <div class="col-sm-6">
                                                <input type="year" name="parentaddress" value={this.state.parent.uud_address} class="form-control"
                                                    onChange={(e) => this.setState({ parent: { ...this.state.parent, uud_address: e.target.value } })} />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label">Student Age *</label>
                                            <div class="col-sm-4">
                                                <input type="year" name="studentage" value={this.state.studentage} class="form-control"
                                                    onChange={(e) => this.setState({ studentage: e.target.value })} />
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-sm-2 col-form-label">Student Address*</label>
                                            <div class="col-sm-6">
                                                <input type="year" name="studentaddress" value={this.state.student.uud_address} class="form-control"
                                                    onChange={(e) => this.setState({ student: { ...this.state.student, uud_address: e.target.value } })} />
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row spetdiv pt-3" style={{ borderBottom: "2px solid #ccc" }}>
                                        <div class="col-12">
                                            <h3>Fee BreakUp </h3>
                                        </div>
                                        <div class="table-responsive pt-3">
                                            <table class="table align-items-center">
                                                <thead style={{ backgroundColor: "transparent" }}>
                                                    <tr><th width="5%">SNo.</th>
                                                        <th width="10%">Year</th>
                                                        <th width="15%">Start Date</th>
                                                        <th width="15%">End Date</th>
                                                        <th width="10%">Fees</th>
                                                        <th width="10%">Tax</th>
                                                        <th width="11%">Due Date</th>
                                                    </tr></thead>
                                                <tbody>
                                                    
                                                    {(() => {
                                                        let Fragment = [];
                                                        
                                                        for (let j = 1; j <=12; j++) {
                                                            var frstdate="frstdate_"+j;
                                                            var frenddate="frenddate_"+j;
                                                            var frduedate="frduedate_"+j;
                                                            var frfees="frfees_"+j;
                                                            var frtax="frtax_"+j;
                                                            const rowRequired = this.isFeeBreakupRowActive(j);
                                                            Fragment.push(<tr>
                                                                <td>{j}</td>
                                                                <td>
                                                                    <FormGroup>
                                                                        <Label for="Select" style={{ fontWeight: "bold" }}>Select</Label>
                                                                        <Selectsearch
                                                                            options={financialyear.map(finval => ({ value: finval.id, label: finval.name }))}
                                                                            value={financialyear.find(obj => obj.value === this.state['finyearfee'+j])}
                                                                            onChange={(e) => this.selfinyearfee(e, j)}
                                                                            search
                                                                            required={rowRequired}
                                                                        />
                                                                    </FormGroup>
        
                                                                </td>
                                                                <td>
                                                                    <DatePicker className="form-control" id={frstdate} name={frstdate} autoComplete="off" required={rowRequired}
                                                                        selected={this.state['startdatefee'+j]}
                                                                        onChange={(e) => this.startfeedate(e, 1, j)}
                                                                        dateFormat='yyyy-MM-dd'
                                                                        peekNextMonth
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <DatePicker className="form-control" id={frenddate} name={frenddate} autoComplete="off" required={rowRequired}
                                                                        selected={this.state['enddatefee'+j]}
                                                                        onChange={(e) => this.startfeedate(e, 2, j)}
                                                                        dateFormat='yyyy-MM-dd'
                                                                        peekNextMonth
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        className="form-control"
                                                                        type="number"
                                                                        name={frfees}
                                                                        id={`frfees_`+j+`_${this.props.id}`}
                                                                        onChange={this.calculateTax}
                                                                        data-field-number={j}
                                                                        required={rowRequired}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        name={frtax}
                                                                        id={frtax}
                                                                        readOnly
                                                                        value={this.state[`frtax_`+j] || ''}
                                                                        required={rowRequired}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <DatePicker className="form-control" id={frduedate} name={frduedate} autoComplete="off" required={rowRequired}
                                                                        selected={this.state['execdatefee'+j]}
                                                                        onChange={(e) => this.startfeedate(e, 3, j)}
                                                                        dateFormat='yyyy-MM-dd'
                                                                        peekNextMonth
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                    />
                                                                </td>                                                        
                                                            </tr>);

                                                        }

                                                        return Fragment;
                                                 
                                                    })()}    
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div style={{ borderBottom: "2px solid #ccc", paddingBottom: "20px", paddingTop: "20px" }}>
                                        <div className="dfsdf"><strong>Program Inclusions</strong></div>
                                        <br></br>
                                        <table class="table align-items-center">
                                            <thead style={{ backgroundColor: "transparent" }}>
                                                <tr><th width="5%">SNo.</th>
                                                    <th>Name</th>
                                                    <th></th>
                                                </tr></thead>
                                            <tbody>
                                                {allagreementprogram.map((p, index) => (
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{p.name}</td>
                                                        <td>
                                                            <input
                                                                class="form-check-input form-check-input-lg"
                                                                type="checkbox"
                                                                name="programinclusion[]"
                                                                value={p.id}
                                                                style={{ height: "3rem", width: "3rem", position: "relative" }}
                                                                onChange={(e) => this.handleCheckboxChange(e, p.id)}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="form-group" style={styles.wrapper}>
                                        <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" disabled={this.state.loader} style={{ margin: "0 auto", marginTop: "20px" }}>Submit</button>
                                        {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}
                                    </div>

                                </RctCollapsibleCard>
                            </form>
                        </div>
                    </div>
                )}
                {this.state.addprogram &&
                    <AddPrograms onClick={this.onBackSection} data={this.state} />
                }

            </>
        )
    }
}
const mapStateToProps = ({ contractstudent }) => {
    const { particularcontractstudent, allagreementfinancial, allagreementtype, allagreementfor, allagreementprogram, loading } = contractstudent;
    return { particularcontractstudent, allagreementfinancial, allagreementtype, allagreementfor, allagreementprogram, loading };

}

export default connect(mapStateToProps, {
    addAgreement,
    agreementAllDetails,
})(AddAgreement);